<template lang="pug">
	.flex-col.space.full-height.app-core--popup-body
		slot(v-if="$scopedSlots['header']", name="header")
		DxScrollView(ref="scrollView", height="100%", showScrollbar="always", direction="both")
			.content(ref="content")
				slot
		.flex-col.space
			slot(v-if="$scopedSlots['actions-top']", name="actions-top")
			.flex-row.justify(v-if="$scopedSlots['actions-left'] || $scopedSlots['actions-right'] || $scopedSlots['actions-top']")
				.left.flex-row.space.align-center
					slot(name="actions-left")
				.right.flex-row.space.align-center
					slot(name="actions-right")
</template>

<script>
	import DxScrollView from 'devextreme-vue/scroll-view';
	import resizeObserver from 'resize-observer';

	export default {
		name: 'app-core--popup-body',
		components: {
			DxScrollView
		},
		mounted() {
			if (__DEBUG__)
				window.popupBodyScrollView = this;
			this.$unobserve = resizeObserver.observe(this, this.$refs.content, () => {
				if (__DEBUG__)
					console.debug('Popup content observer');
				this.refresh();
			});
		},
		methods: {
			refresh() {
				if (this.$refs.scrollView?.instance)
					this.$refs.scrollView.instance.scrollBy(1);
				this.$nextTick(() => {
					if (this._isDestroyed) return;
					this.$refs.scrollView.instance.scrollBy(-1);

					this.$emit('content-changed', this.$refs.content?.offsetHeight);
					this.$nextTick(() => {
						if (this._isDestroyed) return;
						this.$refs.scrollView.instance.release();
					})
				});
			}
		}
	};
</script>
<style lang='scss'>
	.app-core--popup-body {

	}
</style>
